// Defers non-critical third-party work until the page has settled. Mirrors the
// scheduling already used by userway-script.tsx and ms-clarity.ts so all three
// third parties behave the same way.
//
// The interaction listeners matter for analytics specifically: a visitor who
// scrolls or taps is an engaged session we want measured immediately, not one
// we hold back for the full idle window.

const IDLE_TIMEOUT_MS = 2000;
const FALLBACK_DELAY_MS = 1500;
const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'scroll'] as const;

export default function scheduleWhenPageSettles(callback: () => void) {
  let hasRun = false;

  const run = () => {
    if (hasRun) {
      return;
    }

    hasRun = true;

    for (const eventName of INTERACTION_EVENTS) {
      globalThis.removeEventListener(eventName, run);
    }

    callback();
  };

  for (const eventName of INTERACTION_EVENTS) {
    globalThis.addEventListener(eventName, run, { once: true, passive: true });
  }

  const schedule = () => {
    if ('requestIdleCallback' in globalThis) {
      globalThis.requestIdleCallback(run, { timeout: IDLE_TIMEOUT_MS });
      return;
    }

    globalThis.setTimeout(run, FALLBACK_DELAY_MS);
  };

  if (document.readyState === 'complete') {
    schedule();
    return;
  }

  globalThis.addEventListener('load', schedule, { once: true });
}
